import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqPOST, reqPUT, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';
import { companycode } from "../../../../Hosts";

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const audit_list = useRef(null);
    const audit_active = useRef(null);
    const new_year = useRef(null);
    const year_active = useRef(null);
    const years_actives = useRef(null);
        
    const audit_types = useRef(null);
    const new_row = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0);

    const get_info = async () => {

        let res_1 = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/audit_type`)
        set_dados(audit_types.current = res_1.data)

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined) {
                    set_dados(audit_list.current = res.data);

                    let aux = 0
                    let array_aux = []
                    let array_ano_aux = []
                    res.data.forEach(e => {
                        
                    })

                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            set_dados(year_active.current = '')

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_state = (element) => {

        let result = '<span className="badge rounded-0 bg-light text-dark p-3 fs-6">' + language[lang].action_not_open + '</span>'

        if(element?.info?.action?.analysis?.ac_am !== undefined) {

            if(element.info.action.analysis.ac_am === true) {

                if(element?.info?.action?.results?.responsable?.execution !== undefined && element?.info?.action?.results?.responsable?.execution !== null && element.info.action.results.responsable.execution !== '') {
                    if(element?.info?.action?.results?.value !== undefined && parseInt(element.info.action.results.value) === 1) {
                        result = '<span className="badge rounded-0 bg-success p-3 fs-6">' + language[lang].effective + '</span>'
                    }
                    else if(element?.info?.action?.results?.value !== undefined && element?.info?.action?.results?.value !== null && parseInt(element.info.action.results.value) === 0) {
                        result = '<span className="badge rounded-0 bg-danger p-3 fs-6">' + language[lang].not_effective + '</span>'
                    }
                }
                else if(element?.info?.action?.improvement?.responsable?.execution !== undefined && element?.info?.action?.improvement?.responsable?.execution !== null && element.info.action.improvement.responsable.execution !== '') {
                    result = '<span className="badge rounded-0 bg-warning text-dark p-3 fs-6">' + language[lang].for_evaluating + '</span>'
                }
                else {
                    result = '<span className="badge rounded-0 bg-orange text-dark p-3 fs-6">' + language[lang].action_to_be_taken + '</span>'
                }

            }
        }

        return result
    }
    
    const columns = [
        {
            name: language[lang].field_number,
            selector: 'info.number',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_type,
            selector: 'info.settings.occurrence_type',
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_date,
            selector: 'info.action.identification.notification',
            cell: row => (
                row?.info?.action?.identification?.responsable?.notification !== undefined && row.info.action.identification.responsable.notification !== '' ? row.info.action.identification.responsable.notification.split('T')[0] : ''
            ),
            width: '10% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].field_name,
            selector: 'info.name',
            width: '45% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_state,
            cell: row => (
                parse(get_state(row))
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current !== null && permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data,
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const add_new_year = async () => {


        const { value: year } = await Swal.fire({
            input: "text",
            inputLabel: "Ano",
            inputPlaceholder: "Inserir o ano"
        });

        if (year !== '') {
            if(!Array.isArray(years_actives.current)) {
                years_actives.current = []
            }

            set_dados(new_year.current = year)
            set_dados(year_active.current = year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: year
                }
            }))

            change_year(year)

            setRefresh(r => r + 1)

        }


        /*
        if(years_actives.current !== undefined && years_actives.current !== null && years_actives.current.length > 0) {

            let last_year = years_actives.current[years_actives.current.length - 1]
            let aux_year = parseInt(last_year.info.name) + 1
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            set_dados(years_actives.current.push({
                id: '',
                info: {
                    name: aux_year
                }
            }))

            change_year(aux_year)

        }
        else {
            let aux_year = new Date().getFullYear()
            set_dados(new_year.current = aux_year)
            set_dados(year_active.current = aux_year)

            let aux = {
                id: '',
                info: {
                name: aux_year
            }
            }

            set_dados(years_actives.current = [aux])

            change_year(aux_year)
        }

        */
    }

    const change_year = async (year) => {


        console.log('year', year)
        console.log('years_actives.current', years_actives.current)


        if(audit_list.current !== undefined && audit_list.current !== null && audit_list.current.length > 0) {

            for await (let el of audit_list.current) {
                console.log('el.name', el.name)
                console.log('year', year)
                if(el.name.toString() === year.soString()) {            
                    set_dados(audit_active.current = el)
                }


                console.log('1111111')


            }

        }
        else {
            let aux = {
                id: '',
                info: {
                    name: year,
                    companycode: getTokenInfo().companycode,
                    type: 'audit_management',
                    settings: []
                }
            }
            set_dados(audit_active.current = aux)

            
                console.log('222222')

        }

    }


    const add_row = () => {

        if(new_row.current === undefined || new_row.current === null) {
            new_row.current = []
        }

        set_dados(new_row.current.push({
            id: Date.now()
        }))

    }

	const change_settings = (e) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset
		
		if (new_row.current === undefined) {
			new_row.current = []
		}

		new_row.current.forEach(el => {
			if(parseInt(el.id) === parseInt(id)) {
                el[name] = value
			}
		})

		set_dados(new_row.current, )

		setRefresh(r => r + 1)

		console.log('new_row.current', new_row.current)

	}

    const save_row = async () => {

        if(audit_active.current.info.settings === undefined || audit_active.current.info.settings) {
            audit_active.current.info.settings = []
        }

        audit_active.current.info.settings.push(new_row.current[0])

        if(audit_active.current.id === '') {
            await reqPOST(api_crud_route, audit_active.current)
        }
        else {
            await reqPUT(api_crud_route, audit_active.current)
        }

    }

    return (isloading ?

        <Loader />

    :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                    </div>
                                    <div className="table-body audit-management-list">
 
                                        <div className="row">
                                            <div className="col-12 mb-3 d-flex">
                                                {
                                                years_actives.current !== undefined && years_actives.current !== null ?
                                                    years_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-secondary me-2 rounded-0" + (parseInt(dt_el.info.name) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(year_active.current)} >{dt_el.info.name}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                                <div>
                                                    <button type="button" className={"btn btn-sm btn-secondary me-2 rounded-0"} onClick={() => add_new_year()} >+ Adicionar ano</button>
                                                </div>
                                            </div>

                                            <div className="col-12 mb-3">
                                                {
                                                year_active?.current !== undefined && year_active?.current !== null && year_active.current !== '' && 
                                                audit_active?.current?.info?.name !== undefined && audit_active?.current?.info?.name !== null && parseInt(audit_active.current.info.name) === parseInt(year_active.current) ?
                                                    <div className="row">

                                                        <div className='col-12 text-end'>
                                                            <button type="button" className='btn btn-sm btn-secondary rounded-0 mt-4' onClick={() => add_row()}>{language[lang].add_new}</button>
                                                        </div>

                                                        <div className="div-table">
                                                            <div className="table-header text-end mb-8">
                                                            </div>
                                                            <div className="table-body audit-management-list">
                        
                                                                <div className="row">

                                                                    <div className="col-12 mb-3">
                                                                        {
                                                                        audit_active?.current?.info?.settings !== undefined && audit_active?.current?.info?.settings !== null &&  Array.isArray(audit_active.current.info.settings) && audit_active.current.info.settings.length > 0 ?
                                                                            <div className="mb-5">                                                                            
                                                                                <div className="div-table">
                                                                                    <div className="table-body table-responsive">
                                                                                        <table className="table audit-management-list table-hover table-bordered align-middle">
                                                                                            <thead className="text-center align-middle">
                                                                                                <tr>
                                                                                                    <th>
                                                                                                        N.º
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Data prevista
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Tipo
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Área a auditar
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Âmbito
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Objectivos
                                                                                                    </th>
                                                                                                    <th>
                                                                                                        Entidade Auditora / Auditoe Líder
                                                                                                    </th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {
                                                                                                audit_active.current.info.settings.map((el_al, key_al) => {
                                                                                                    return(
                                                                                                        <tr key={key_al}>
                                                                                                            <td>{key_al + 1}</td>
                                                                                                            <td>{el_al.date}</td>
                                                                                                            <td>{el_al.type}</td>
                                                                                                            <td>{el_al.area}</td>
                                                                                                            <td>{el_al.scope}</td>
                                                                                                            <td>{el_al.description}</td>
                                                                                                            <td>{el_al.audit_entity}</td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                })
                                                                                                }
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        :
                                                                            null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='col-12'>
                                                            {
                                                            new_row.current !== undefined && new_row.current !== null ?
                                                                new_row.current.map((el_settings, key_settings) => {
                                                                    return (
                                                                        <div key={key_settings} className={'row p-3' + (key_settings % 2 !== 0 ? ' bg-light' : '')}>

                                                                            <div className="col-4 col-md-2 mt-3">
                                                                                <label className={"fs-6 fw-bold mb-2"}>Data prevista</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="date"
                                                                                    data-id={el_settings.id}
                                                                                    value={el_settings?.date !== undefined && el_settings?.date !== null ? el_settings?.date : ''}
                                                                                    onChange={(e) => change_settings(e)}
                                                                                    className="form-control rounded-0" />
                                                                            </div>

                                                                            <div className="col-4 col-md-2 mt-3">
                                                                                <label className="fs-6 fw-bold mb-2">{language[lang].field_type}</label>
                                                                                <select
                                                                                    name="type"
                                                                                    data-id={el_settings.id}
                                                                                    className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                    onChange={(e) => change_settings(e)}
                                                                                    value={el_settings?.type !== undefined && el_settings?.type !== null ? el_settings?.type : ''}
                                                                                >
                                                                                    <option value="">{language[lang].field_choose}</option>
                                                                                    <option value="52">Interna</option>
                                                                                    <option value="53">Externa</option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="col-4 col-md-2 mt-3">
                                                                                <label className={"fs-6 fw-bold mb-2"}>Área a auditar</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="area"
                                                                                    data-id={el_settings.id}
                                                                                    value={el_settings?.area !== undefined && el_settings?.area !== null ? el_settings?.area : ''}
                                                                                    onChange={(e) => change_settings(e)}
                                                                                    className="form-control rounded-0" />
                                                                            </div>

                                                                            <div className="col-4 col-md-2 mt-3">
                                                                                <label className={"fs-6 fw-bold mb-2"}>Âmbito</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="scope"
                                                                                    data-id={el_settings.id}
                                                                                    value={el_settings?.scope !== undefined && el_settings?.scope !== null ? el_settings?.scope : ''}
                                                                                    onChange={(e) => change_settings(e)}
                                                                                    className="form-control rounded-0" />
                                                                            </div>

                                                                            <div className="col-4 col-md-4 mt-3">
                                                                                <label className={"fs-6 fw-bold mb-2"}>Entidade auditora / Auditor líder</label>
                                                                                <input
                                                                                    type="text"
                                                                                    name="audit_entity"
                                                                                    data-id={el_settings.id}
                                                                                    value={el_settings?.audit_entity !== undefined && el_settings?.audit_entity !== null ? el_settings?.audit_entity : ''}
                                                                                    onChange={(e) => change_settings(e)}
                                                                                    className="form-control rounded-0" />
                                                                            </div>

                                                                            <div className="col-12"></div>
                                                                            
                                                                            <div className="col-6 col-md-6 mt-3">
                                                                                <label className={"fs-6 fw-bold mb-2"}>Objectivos</label>
                                                                                <textarea 
                                                                                    type="text" 
                                                                                    rows="4" 
                                                                                    name="description" 
                                                                                    data-id={el_settings.id}
                                                                                    value={el_settings?.description !== undefined && el_settings?.description !== null ? el_settings?.description : ''}
                                                                                    onChange={(e) => change_settings(e)} 
                                                                                    className="form-control rounded-0" 
                                                                                />
                                                                            </div>

                                                                            <div className='col-12 text-end'>
                                                                                <button type="button" className='btn btn-sm btn-secondary rounded-0 mt-4' onClick={() => save_row()}>{language[lang].save}</button>
                                                                            </div>

                                                                        </div>
                                                                    )
                                                                })
                                                            :
                                                                null
                                                            }
                                                        </div>

                                                    </div>
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}